export const trialConfig = {
  priceNormal: 500000,
  discountPercent: 50,
  payAfterTrial: 250000,
  durationDays: 30,
  brand: "Dreams Marketing",
  bankAccounts: [
    {
      bank: "Mandiri",
      number: "1330014795553",
      name: "Fera Handiani",
    },
    {
      bank: "BSI (Mandiri Syariah)",
      number: "7106531786",
      name: "Fera Handiani",
    },
    {
      bank: "BCA",
      number: "8720296765",
      name: "Fera Handiani",
    },
  ],
};
